import { column, edge, flow, makeFlow, node } from "../builders";
import type { TemplateDef } from "../types";

const seq = column("f1", 100, 70, 92, [
  ["t1", "auto-trigger", "Application submitted", { props: { triggerType: "Form Submitted", event: "Coaching application" } }],
  ["c1", "auto-condition", "Qualified on budget and timing?", { props: { condition: "budget is at least $3,000 AND ready_within is 60 days" } }],
  ["e1", "auto-email", "You're a fit — book your call", { props: { subject: "Read your application — let's talk" } }],
  ["e2", "auto-email", "Not a fit right now", { props: { subject: "Honest answer, plus the self-paced option" } }],
  ["w1", "auto-wait", "Wait 1 day", { props: { duration: "1", unit: "days" } }],
  ["c2", "auto-condition", "Call booked?", { props: { condition: "Has tag 'call-booked'" } }],
  ["s1", "auto-sms", "Your application is still open", { props: { message: "Hi {{contact.first_name}} — your spot is held until Friday: {{link.calendar}}" } }],
  ["w2", "auto-wait", "Wait 2 days", { props: { duration: "2", unit: "days" } }],
  ["e3", "auto-email", "Last call on this month's spots", { props: { subject: "Closing applications for this cohort" } }],
  ["p1", "auto-pipeline", "Application → Call Booked", { props: { pipeline: "Coaching", stage: "Call Booked" } }],
]);

const def: TemplateDef = {
  slug: "discovery-call-application",
  name: "Discovery Call Application",
  category: "Coaching",
  tagline:
    "Make them apply, disqualify kindly, and only put booked calls on your calendar.",
  description:
    "A free coaching application funnel template: an application form qualifies on budget and timing, fits get a booking link and unfits get an honest no plus a self-paced option, and a two-step nudge chases the people who never booked. Clone it into FrazzleCRM and protect your calendar.",
  whatsInside: [
    "Application form instead of an open calendar link",
    "Qualification branch on budget and readiness, both on contact fields",
    "A real, kind decline that still offers a lower-priced path",
    "SMS and email nudges for applicants who never picked a time",
  ],
  flow: makeFlow(
    [
      node("src1", "traffic-instagram", "Instagram", 40, 60),
      node("src2", "traffic-youtube", "YouTube", 40, 220),
      node("ap", "page-survey", "Application", 360, 140, { props: { questions: "9" } }),
      flow("f1", "Application Triage", 680, 40, 420, 1040),
      ...seq.nodes,
      node("bk", "page-booking", "Discovery call", 1200, 260, { props: { duration: "45 min" } }),
      node("sp", "page-sales", "Self-paced option", 1200, 440, { props: { price: "$297" } }),
      node("out", "outcome-appointment", "Call booked", 1520, 260),
      node("n1", "util-note", "Why an application beats a calendar link", 360, 340, {
        notes:
          "An open calendar fills with people who cannot buy. Nine questions costs you the tyre-kickers and buys back the hours — and the answers are the first half of the sales call.",
      }),
    ],
    [
      edge("src1", "ap"),
      edge("src2", "ap"),
      edge("ap", "f1"),
      ...seq.edges,
      edge("f1", "bk"),
      edge("f1", "sp"),
      edge("bk", "out"),
    ]
  ),
};

export default def;
